import React from "react";
import { Header, Footer } from "./";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <main>
      <Header />
      <div className={`tc-body-wrapper pt-0 rx-main-layout`}>
        <div className="tc_main_version_wrapper">
          <span className="tc_main_version_content">
            Test version {process.env.REACT_APP_VERSION}
          </span>
        </div>
        <div className="tc-body">
          <Outlet />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default MainLayout;
